/* eslint-disable */
export const REGEX_PASSWORD = /^(?=.*[0-9])(?=.*[- ?!@#$%^&*\/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\/\\]{8,30}$/;

export const REGEX_URL = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;


export const TWO_DECIMAL_REGEX = /^([0-9]*(\.[0-9]{0,2})?)$/;

export const ONLY_INTEGER = /^\-?\d+$/;
